import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { GridHeadersRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetSampleJLUploadFilesUseCase implements UseCase<BaseRequest<any>, HttpResponse<Blob>> {

  constructor(private gridHeadersRepository:GridHeadersRepository) {
  }

  execute(): Observable<HttpResponse<Blob>> {
    return this.gridHeadersRepository.getSampleJLUploadFiles();
  }

}